import gql from 'graphql-tag'

export const fetchHPCartQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  ) {
    delivery_date
    delivery_method
    id
    ship_to_id
    grand_total_your_price_details
    items {
      id
      uid
      product {
        sku
        name
        image {
          url
        }
      }
      quantity_total
    }
    progress_bar_data {
      iMinimumOrderPallet,
      iMaximumOrderPallet,
      iMinimumOrderWeight,
      iMaximumOrderWeight,
      iMinimumUnit,
      iMaximumUnit,
      iKegFlag,
      iCustomerType,
      iTotalCartWeight,
      iTotalCartPalletQty,
      iTotalQty,
      msg,
      canProceed
    }
  }
}
`)
